import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import './assets/nicepage.css'
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import VueThaiAddressInput from 'vue-thai-address-input'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-thai-address-input/dist/vue-thai-address-input.css'

Vue.config.productionTip = false

Vue.use(VueSweetalert2);
Vue.use(VueThaiAddressInput);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


